import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./CSS/Home.css";

const Home = ({ onContactClick }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleContactClick = () => {
    setMenuOpen(false); // Close menu on mobile
    if (onContactClick) {
      onContactClick();
    }
  };

  return (
    <div className="home-container">
      <Helmet>
        <title>DesignVio | Elevate Your Business with Innovative Design</title>
        <meta
          name="description"
          content="Unlock the full potential of your brand with DesignVio's cutting-edge UI/UX and full stack development courses in Satara."
        />
        <meta name="keywords" content="UI/UX, Full Stack Development, DesignVio, Satara, Innovative Design" />
        <link rel="canonical" href="https://designvio.in/" />
      </Helmet>

      <header className="home-header">
        <div className="logo">
          <img
            alt="Designvio.pvt.Ltd"
            className="logo-icon"
            src="../Images/DLogo.png"
          />
        </div>

        <div className="hamburger" onClick={toggleMenu}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>

        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <Link to="#about">ABOUT</Link>
          <Link to="#services">SERVICES</Link>
          <Link to="#work">WORK</Link>
          <Link to="contactus" onClick={handleContactClick}>
            CONTACT
          </Link>
        </nav>
      </header>

      <main className="main-content">
        <h1>
          <span className="highlight-yellow">ELEVATE</span> YOUR BUSINESS
        </h1>
        <h1>
          WITH <span className="highlight-yellow">INNOVATIVE</span> DESIGN
        </h1>
        <p>
          Unlock the full potential of your brand with cutting-edge design
          solutions. Let's bring your vision to life with creativity and
          strategy!
        </p>
        <Link to="#about" className="cta-button">
          LEARN MORE
        </Link>
      </main>
    </div>
  );
};

export default Home;